import React, { Fragment } from "react";
import {
  Page,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  ListItemCell,
  Icon,
  Button,
  Row,
  Col,
  Checkbox,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Popup,
  Toggle,
  Preloader,
  Badge,
  Stepper,
  Popover,
  Range,
} from "framework7-react";

import {
  PrimaryLogo,
  MerchantSvg,
  BikeSvg,
  WalletSvg,
} from "../components/crumbs";

import moment from "moment";
import * as geofire from "geofire-common";

// Redux
import { connect } from "react-redux";
import { compose } from "redux";
import { getDistance, convertDistance } from "geolib";
import { withStorage, firestoreConnect } from "../HOCs";
import { Collections, Doc, DocArray } from "../utils/_classes";
import { handleErrors, toast } from "../utils/_helpers";

class Merchant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
      },

      // closest branches
      nearestBranches: [],

      // Order filter
      orderFilter: {
        customerName: "",
        phoneNumber: "",
      },

      // Process delivery
      processDeliveryButton: "Process Order",
      selectedDeliveryAgent: "",
      deliveryAgentsRange: 15,

      // Cancel
      declineOrderButton: "Decline Order",

      // merchant confirm order
      confirmationCode: "",
      completeOrderButton: "Complete Order",
    };
  }

  render() {
    if (!this.props.merchants[this.props.auth.uid]) {
      return (
        <Page>
          <Block className="pattern-banner bg-color-theme">
            <Card style={{ width: "100%", margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0 }}>Become a merchant </h3>
                <Button fill href="/business-registration/1/">
                  Merchant Registration
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: "center", marginTop: "10vh" }}>
              <MerchantSvg size="300px" />
              <h6>Earn more profit selling online with Easychaw</h6>
            </div>
          </Block>
        </Page>
      );
    }

    if (this.props.merchants[this.props.auth.uid].accountStatus == "Pending") {
      return (
        <Page>
          <Block className="pattern-banner bg-color-orange">
            <Card style={{ width: "100%", margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0, color: "#ef6c00" }}>
                  Application Pending{" "}
                </h3>
                <Button
                  fill
                  tabLink="#view-message-master"
                  onClick={() => this.navMessage("account", "admin", "account")}
                >
                  Contact Admin
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: "center", marginTop: "10vh" }}>
              <img src="static/relax.svg" style={{ width: "300px" }} />
              <h6>
                Please contact Admin after 24 hours <br /> if account is still
                pending.
              </h6>
            </div>
          </Block>
        </Page>
      );
    }

    if (
      this.props.merchants[this.props.auth.uid].accountStatus == "Suspended"
    ) {
      return (
        <Page>
          <Block className="pattern-banner bg-color-pink">
            <Card style={{ width: "100%", margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0, color: "#E02020" }}>
                  Account Suspended{" "}
                </h3>
                <Button
                  className="button-fill-red"
                  tabLink="#view-message-master"
                  onClick={() => this.navMessage("account", "admin", "account")}
                >
                  Contact Admin
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: "center", marginTop: "10vh" }}>
              <img src="static/cancel.svg" style={{ width: "300px" }} />
              <h6>
                Access Denied <br /> Please contact admin
              </h6>
            </div>
          </Block>
        </Page>
      );
    }

    return (
      <Page>
        <Block>
          <Row>
            <Col width="100" className="xsmall-100">
              <Card
                className="data-table data-table-init"
                style={{
                  width: "100%",
                  marginLeft: "0px",
                  maxHeight: "700px",
                }}
              >
                <CardHeader>
                  <div className="data-table-title">All Orders</div>
                </CardHeader>
                <CardContent
                  padding={false}
                  style={{
                    width: "100%",
                    maxHeight: "600px",
                    overflow: "scroll",
                  }}
                >
                  {this.props.loadingDoc && !this.props.orders ? (
                    <Block className="text-align-center">
                      <Preloader></Preloader>
                    </Block>
                  ) : !this.props.loadingDoc &&
                    this.props.orders &&
                    this.props.orders.length > 0 ? (
                    <table className="sticky">
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">Action</span>
                          </th>
                          <th>
                            <span className="table-head-label">Order ID</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Order Current Status
                            </span>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Customer name
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                placeholder="Filter"
                                value={this.state.orderFilter.customerName}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    orderFilter: {
                                      ...this.state.orderFilter,
                                      customerName: e.target.value,
                                    },
                                  })
                                }
                              />
                            </div>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Customer Phone
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                placeholder="Filter"
                                value={this.state.orderFilter.phoneNumber}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    orderFilter: {
                                      ...this.state.orderFilter,
                                      phoneNumber: e.target.value,
                                    },
                                  })
                                }
                              />
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">Order ID</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Order Amount
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              % Commission
                            </span>
                          </th>
                          <th>
                            <span className="table-head-label">Net Amount</span>
                          </th>
                          <th>
                            <span className="table-head-label">
                              Order Timestamp
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.orders
                          .filter(
                            (order) =>
                              order.fullName
                                .toLowerCase()
                                .includes(
                                  this.state.orderFilter.customerName.toLowerCase(),
                                ) &&
                              order.phoneNumber.includes(
                                this.state.orderFilter.phoneNumber,
                              ),
                          )
                          .sort(
                            (a, b) =>
                              +moment(b.timestamp) - +moment(a.timestamp),
                          )
                          .sort((a, b) => {
                            if (a.orderStatus === "Order Cancelled") {
                              if (b.orderStatus === "Order Completed")
                                return -1;
                              if (
                                b.orderStatus === "Order Pending" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus === "Order Pending Confirmation"
                              )
                                return 1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Pending Delivery") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              if (b.orderStatus === "Order Pending") return 1;
                              return 0;
                            }

                            if (
                              a.orderStatus === "Order Pending Confirmation"
                            ) {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              if (
                                b.orderStatus === "Order Pending" ||
                                b.orderStatus === "Order Pending Confirmation"
                              )
                                return 1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Pending") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Completed") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Pending"
                              )
                                return 1;
                              return 0;
                            }
                          })
                          .map((order) =>
                            order.orderStatus === "Order Pending" ? (
                              <tr key={order.id}>
                                <td>
                                  <Button
                                    fill
                                    onClick={() =>
                                      this.setState({
                                        popupOpened: true,
                                        popupDataChanged: true,
                                        popupData: {
                                          title: "Process Order",
                                          which: "process-order",
                                          order,
                                        },
                                      })
                                    }
                                  >
                                    Process
                                  </Button>
                                </td>
                                <td>
                                  <div>{order.id}</div>
                                </td>
                                <td>
                                  <div>{order.orderStatus}</div>
                                </td>
                                <td>
                                  <div>{order.fullName}</div>
                                </td>
                                <td>
                                  <div>{order.phoneNumber}</div>
                                </td>
                                <td>{order.id}</td>
                                <td>
                                  <div>
                                    {new Intl.NumberFormat("en-GB", {
                                      style: "currency",
                                      currency: "NGN",
                                    }).format(order.totalAmount)}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ color: "red" }}>
                                    {order.commissionFreeSales === null ||
                                    order.commissionFreeSales === undefined ||
                                    order.commissionFreeSales === 0 ||
                                    order.merchantCompletedOrders === null ||
                                    order.merchantCompletedOrders ===
                                      undefined ||
                                    order.merchantCompletedOrders >=
                                      order.commissionFreeSales
                                      ? new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(
                                          order.totalAmount -
                                            order.totalMerchantAmount,
                                        )
                                      : "Free"}{" "}
                                    {order.commissionFreeSales === null ||
                                    order.commissionFreeSales === undefined ||
                                    order.commissionFreeSales === 0 ||
                                    order.merchantCompletedOrders === null ||
                                    order.merchantCompletedOrders ===
                                      undefined ||
                                    order.merchantCompletedOrders >=
                                      order.commissionFreeSales
                                      ? `(${order?.commissionOnSales || 3.5}%)`
                                      : ""}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {order.commissionFreeSales === null ||
                                    order.commissionFreeSales === undefined ||
                                    order.commissionFreeSales === 0 ||
                                    order.merchantCompletedOrders === null ||
                                    order.merchantCompletedOrders ===
                                      undefined ||
                                    order.merchantCompletedOrders >=
                                      order.commissionFreeSales
                                      ? new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(order.totalMerchantAmount)
                                      : new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(order.totalAmount)}
                                  </div>
                                </td>
                                <td>
                                  <div>{moment(order.timestamp).fromNow()}</div>
                                </td>
                              </tr>
                            ) : (
                              <tr key={order.id}>
                                <td>
                                  <Button
                                    className={
                                      order.orderStatus === "Order Rejected" ||
                                      order.orderStatus === "Order Cancelled"
                                        ? "button-outline"
                                        : order.orderStatus ===
                                          "Order Completed"
                                        ? "button-outline"
                                        : "button-fill"
                                    }
                                    disabled={
                                      order.orderStatus === "Order Cancelled"
                                    }
                                    onClick={() =>
                                      this.setState({
                                        popupOpened: true,
                                        popupDataChanged: true,
                                        popupData: {
                                          title: "Processed Order",
                                          which: "processed-order",
                                          order,
                                        },
                                      })
                                    }
                                  >
                                    {order.orderStatus === "Order Rejected"
                                      ? "Issue"
                                      : order.orderStatus === "Order Cancelled"
                                      ? "Declined"
                                      : "Processed"}
                                  </Button>
                                </td>
                                <td>
                                  <div>{order.id}</div>
                                </td>
                                <td>
                                  <div>{order.orderStatus}</div>
                                </td>
                                <td>
                                  <div>{order.fullName}</div>
                                </td>
                                <td>
                                  <div>{order.phoneNumber}</div>
                                </td>
                                <td>{order.id}</td>
                                <td>
                                  <div>
                                    {new Intl.NumberFormat("en-GB", {
                                      style: "currency",
                                      currency: "NGN",
                                    }).format(order.totalAmount)}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ color: "red" }}>
                                    {order.commissionFreeSales === null ||
                                    order.commissionFreeSales === undefined ||
                                    order.commissionFreeSales === 0 ||
                                    order.merchantCompletedOrders === null ||
                                    order.merchantCompletedOrders ===
                                      undefined ||
                                    order.merchantCompletedOrders >=
                                      order.commissionFreeSales
                                      ? new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(
                                          order.totalAmount -
                                            order.totalMerchantAmount,
                                        )
                                      : "Free"}{" "}
                                    {order.commissionFreeSales === null ||
                                    order.commissionFreeSales === undefined ||
                                    order.commissionFreeSales === 0 ||
                                    order.merchantCompletedOrders === null ||
                                    order.merchantCompletedOrders ===
                                      undefined ||
                                    order.merchantCompletedOrders >=
                                      order.commissionFreeSales
                                      ? `(${order?.commissionOnSales || 3.5}%)`
                                      : ""}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {order.commissionFreeSales === null ||
                                    order.commissionFreeSales === undefined ||
                                    order.commissionFreeSales === 0 ||
                                    order.merchantCompletedOrders === null ||
                                    order.merchantCompletedOrders ===
                                      undefined ||
                                    order.merchantCompletedOrders >=
                                      order.commissionFreeSales
                                      ? new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(order.totalMerchantAmount)
                                      : new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(order.totalAmount)}
                                  </div>
                                </td>
                                <td>
                                  <div>{moment(order.timestamp).fromNow()}</div>
                                </td>
                              </tr>
                            ),
                          )}
                      </tbody>
                    </table>
                  ) : (
                    <Block className="block-info">
                      <Row>
                        <Col>
                          <p>No New Or Pending Orders</p>
                        </Col>
                      </Row>
                    </Block>
                  )}
                </CardContent>
              </Card>
            </Col>

            <Col width="100" className="xsmall-100">
              <Card
                className="data-table data-table-init"
                style={{ width: "100%", marginLeft: "0px" }}
              >
                <CardHeader>
                  <div className="data-table-title">Sales Chart</div>
                </CardHeader>
                <CardContent padding={false}>
                  <Block
                    style={{
                      backgroundColor: "#ffe0b2",
                      borderLeft: "3px solid #ff9800",
                      color: "#ef6c00",
                      marginTop: 0,
                      paddingTop: "16px",
                      paddingBottom: "16px",
                      fontSize: "10px",
                    }}
                  >
                    <Row>
                      <Col>
                        <p>Sales Chart Coming Soon!</p>
                      </Col>
                    </Row>
                  </Block>
                </CardContent>
              </Card>
            </Col>
          </Row>
        </Block>

        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "" },
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for process orders */}
            {this.state.popupData.which == "process-order" ? (
              <Block>
                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">Order Items </CardHeader>

                  <CardContent>
                    <List>
                      {this.state.popupData.order.packages.map(
                        (value, index) => (
                          <ListItem
                            className="show-text"
                            title={value.name}
                            key={index}
                          >
                            <b slot="media">{value.count} x &nbsp;</b>
                            <small slot="after">
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(value.amount)}
                            </small>
                          </ListItem>
                        ),
                      )}
                    </List>
                  </CardContent>
                </Card>

                {this.state.popupData.order.deliveryInclusive && (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardContent>
                      <List>
                        <ListItem className="show-text" title="Delivery Charge">
                          <small slot="after">
                            {new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "NGN",
                            }).format(
                              this.state.popupData.order.userDeliveryCharge,
                            )}
                          </small>
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                )}

                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">User Details</CardHeader>

                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.fullName}
                        after="Client Name"
                      >
                        <Icon f7="person_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.deliveryAddress}
                        after="Client Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.phoneNumber}
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                      {this.state.popupData.order.expectedDeliveryTime &&
                      !this.state.popupData.order.postDatedDate ? (
                        <ListItem
                          header="Expected Delivery Time"
                          title={moment(
                            this.state.popupData.order.expectedDeliveryTime,
                          ).format("dddd, MMMM Do, YYYY | hh:mma")}
                          after="EDT"
                        >
                          <Icon f7="cube_box_fill" slot="media" />
                        </ListItem>
                      ) : null}
                      {this.state.popupData.order.instructions &&
                        this.state.popupData.order.instructions.trim() !==
                          "" && (
                          <ListItem
                            className="show-text"
                            title={this.state.popupData.order.instructions}
                            after="Instruction"
                          >
                            <Icon f7="info_circle_fill" slot="media" />
                          </ListItem>
                        )}
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      outline
                      style={{ width: "45%" }}
                      href={`tel://${this.state.popupData.order.phoneNumber}`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.state.popupData.order.phoneNumber,
                        )
                      }
                    >
                      <Icon f7="phone_fill_arrow_up_right" />
                      &nbsp;&nbsp;&nbsp;Contact User
                    </Button>

                    <Button
                      outline
                      style={{ width: "45%" }}
                      onClick={() =>
                        this.$f7.methods.navMessage("Feature coming soon!")
                      }
                    >
                      <Icon f7="bubble_left_bubble_right" />
                      &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                    </Button>
                  </CardFooter>
                </Card>

                {this.state.popupData.order.postDatedDate ? (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardHeader className="no-border">
                      Post Dated Order Details
                    </CardHeader>
                    <CardContent>
                      <List>
                        <ListItem
                          className="show-text"
                          title={moment(
                            this.state.popupData.order.postDatedDate,
                          ).format("dddd, MMMM Do, YYYY | hh:mm")}
                          after="Date | Time"
                        >
                          <Icon f7="info_circle_fill" slot="media" />
                        </ListItem>

                        <ListItem
                          className="show-text"
                          title={
                            this.state.popupData.order.postDatedInstructions
                          }
                          after="Instructions"
                        >
                          <Icon f7="info_circle_fill" slot="media" />
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                ) : null}

                {!this.state.popupData.order.deliveryInclusive ? (
                  <Card
                    className="data-table data-table-init"
                    style={{
                      width: "100%",
                      margin: "10pt auto",
                      maxHeight: "400px",
                    }}
                  >
                    <CardHeader
                      className="no-border"
                      style={{ paddingRight: 0 }}
                    >
                      <div className="data-table-title">Order Delivery</div>
                      {this.state.popupData.order.deliveryRequired &&
                      !this.state.popupData.order.deliveryInclusive ? (
                        <div style={{ width: "50%" }}>
                          <List simpleList style={{ width: "100%" }}>
                            <ListItem>
                              <ListItemCell className="width-auto flex-shrink-0">
                                <Icon f7="car_fill"></Icon>
                              </ListItemCell>
                              <ListItemCell className="flex-shrink-3">
                                <Range
                                  value={this.state.deliveryAgentsRange}
                                  step={5}
                                  min={0}
                                  max={100}
                                  label={true}
                                  onRangeChange={(e) => {
                                    this.setState({
                                      ...this.state,
                                      deliveryAgentsRange: e,
                                    });
                                  }}
                                ></Range>
                              </ListItemCell>
                              <ListItemCell className="width-auto flex-shrink-0">
                                <h6>
                                  <span>{this.state.deliveryAgentsRange}</span>
                                  km
                                </h6>
                              </ListItemCell>
                            </ListItem>
                          </List>
                        </div>
                      ) : null}
                    </CardHeader>

                    {this.state.popupData.order.deliveryRequired ? (
                      <>
                        <CardContent
                          padding={false}
                          style={{
                            width: "100%",
                            maxHeight: "358px",
                            overflow: "scroll",
                          }}
                        >
                          {!this.props.data.delivery[this.props.auth.uid] &&
                          this.props.ordered.delivery &&
                          (!this.props.merchants[this.props.auth.uid]
                            .assignedDeliveryAgents ||
                            this.props.ordered.delivery.filter(
                              (agent) =>
                                agent.currentStatus === "online" &&
                                agent.accountStatus === "Approved" &&
                                this.props.merchants[this.props.auth.uid]
                                  .assignedDeliveryAgents.length > 0 &&
                                this.props.merchants[
                                  this.props.auth.uid
                                ].assignedDeliveryAgents.find(
                                  (id) => id === agent.id,
                                ) &&
                                getDistance(
                                  this.props.merchants[this.props.auth.uid]
                                    .businessProfile.geoLoc,
                                  agent.businessProfile.geoLoc,
                                ) /
                                  1000 <=
                                  this.state.deliveryAgentsRange,
                            ).length <= 0) ? (
                            <Block className="block-info">
                              <small>
                                No available delivery agent within{" "}
                                {this.state.deliveryAgentsRange} km range of
                                your location.{" "}
                                {this.state.deliveryAgentsRange < 100
                                  ? "Please adjust delivery agent range"
                                  : ""}
                              </small>
                            </Block>
                          ) : (
                            <table className="sticky">
                              <thead>
                                <tr>
                                  <th className="checkbox-cell">Assign</th>

                                  <th className="input-cell">
                                    Distance From Merchant
                                  </th>

                                  <th className="input-cell">Vendor Name</th>

                                  <th className="input-cell">Vendor Email</th>

                                  <th className="input-cell">Vendor Phone</th>

                                  <th className="input-cell">Vendor Address</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.data.delivery &&
                                  this.props.data.delivery[
                                    this.props.auth.uid
                                  ] && (
                                    <tr>
                                      <td className="checkbox-cell">
                                        <Checkbox
                                          checked={
                                            this.state.selectedDeliveryAgent ==
                                            this.props.auth.uid
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              ...this.state,
                                              selectedDeliveryAgent:
                                                this.props.auth.uid,
                                            })
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div>
                                          {(
                                            getDistance(
                                              this.props.merchants[
                                                this.props.auth.uid
                                              ].businessProfile.geoLoc,
                                              this.props.data.delivery[
                                                this.props.auth.uid
                                              ].businessProfile.geoLoc,
                                            ) / 1000
                                          ).toFixed(2) + "km away"}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {
                                            this.props.data.delivery[
                                              this.props.auth.uid
                                            ].businessProfile.name
                                          }
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {
                                            this.props.data.delivery[
                                              this.props.auth.uid
                                            ].businessProfile.email
                                          }
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {
                                            this.props.data.delivery[
                                              this.props.auth.uid
                                            ].businessProfile.phone
                                          }
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {
                                            this.props.data.delivery[
                                              this.props.auth.uid
                                            ].businessProfile.address
                                          }
                                        </div>
                                      </td>
                                    </tr>
                                  )}

                                {this.props.ordered.delivery &&
                                  this.props.ordered.delivery
                                    .sort(
                                      (a, b) =>
                                        convertDistance(
                                          getDistance(
                                            this.props.merchants[
                                              this.props.auth.uid
                                            ].businessProfile.geoLoc,
                                            a.businessProfile.geoLoc,
                                          ),
                                          "km",
                                        ) -
                                        convertDistance(
                                          getDistance(
                                            this.props.merchants[
                                              this.props.auth.uid
                                            ].businessProfile.geoLoc,
                                            b.businessProfile.geoLoc,
                                          ),
                                          "km",
                                        ),
                                    )
                                    .filter(
                                      (agent) =>
                                        agent.id !== this.props.auth.uid &&
                                        this.props.merchants[
                                          this.props.auth.uid
                                        ].assignedDeliveryAgents &&
                                        this.props.merchants[
                                          this.props.auth.uid
                                        ].assignedDeliveryAgents.length > 0 &&
                                        this.props.merchants[
                                          this.props.auth.uid
                                        ].assignedDeliveryAgents.find(
                                          (id) => id === agent.id,
                                        ),
                                    )
                                    .filter(
                                      (agent) =>
                                        agent.currentStatus === "online" &&
                                        agent.accountStatus === "Approved" &&
                                        getDistance(
                                          this.props.merchants[
                                            this.props.auth.uid
                                          ].businessProfile.geoLoc,
                                          agent.businessProfile.geoLoc,
                                        ) /
                                          1000 <=
                                          this.state.deliveryAgentsRange,
                                    )
                                    .concat(this.state.nearestBranches)
                                    .sort(
                                      (a, b) =>
                                        convertDistance(
                                          getDistance(
                                            this.props.merchants[
                                              this.props.auth.uid
                                            ].businessProfile.geoLoc,
                                            a?.businessProfile?.geoLoc ||
                                              a.geoLoc,
                                          ),
                                          "km",
                                        ) -
                                        convertDistance(
                                          getDistance(
                                            this.props.merchants[
                                              this.props.auth.uid
                                            ].businessProfile.geoLoc,
                                            b?.businessProfile?.geoLoc ||
                                              b.geoLoc,
                                          ),
                                          "km",
                                        ),
                                    )
                                    .map((agent) => (
                                      <tr key={agent.id}>
                                        <td className="checkbox-cell">
                                          <Checkbox
                                            checked={
                                              this.state
                                                .selectedDeliveryAgent ==
                                              agent.id
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                ...this.state,
                                                selectedDeliveryAgent: agent.id,
                                              })
                                            }
                                          />
                                        </td>
                                        <td>
                                          <div>
                                            {(
                                              getDistance(
                                                this.props.merchants[
                                                  this.props.auth.uid
                                                ].businessProfile.geoLoc,
                                                agent?.businessProfile
                                                  ?.geoLoc || agent?.geoLoc,
                                              ) / 1000
                                            ).toFixed(2) + "km away"}
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {agent?.businessProfile?.name ||
                                              `${agent.headquatersName} - ${agent.name}`}
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {agent?.businessProfile?.email ||
                                              this.props.data.delivery[
                                                agent.HQId
                                              ]?.businessProfile.email}
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {agent?.businessProfile?.phone ||
                                              agent?.phone}
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {agent?.businessProfile?.address ||
                                              agent?.address}
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                              </tbody>
                            </table>
                          )}
                        </CardContent>

                        <CardFooter>
                          <Button
                            round
                            fill
                            style={{
                              width: "45%",
                              backgroundImage:
                                "linear-gradient(#FF6969, #E02020)",
                              color: "white",
                            }}
                            onClick={() =>
                              this.$f7.dialog.confirm(
                                "This order will be cancelled!",
                                "Order",
                                () =>
                                  this.cancleOrder(this.state.popupData.order),
                              )
                            }
                          >
                            {this.state.declineOrderButton} &nbsp;{" "}
                            {this.state.declineOrderButton !==
                              "Decline Order" && <Preloader></Preloader>}
                          </Button>

                          <Button
                            round
                            fill
                            style={{ width: "45%" }}
                            onClick={(e) =>
                              this.processOrder(this.state.popupData.order)
                            }
                          >
                            {this.state.processDeliveryButton} &nbsp;{" "}
                            {this.state.processDeliveryButton !==
                              "Process Order" && <Preloader></Preloader>}
                          </Button>
                        </CardFooter>
                      </>
                    ) : (
                      <CardContent padding={false}>
                        <Block className="pab" style={{ width: "100%" }}>
                          <Row>
                            <Col>
                              <p>Order is for pick up only!</p>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    )}
                  </Card>
                ) : null}

                {!this.state.popupData.order.deliveryRequired ||
                this.state.popupData.order.deliveryInclusive ? (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardHeader className="no-border">
                      Order Confirmation
                    </CardHeader>
                    <CardContent>
                      <List>
                        <ListInput
                          label="Confirmation Code"
                          type="text"
                          placeholder="please enter code here"
                          info="Confirmation code is required"
                          required
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              confirmationCode: e.target.value,
                            })
                          }
                          clearButton
                        >
                          <Icon f7="lock_shield" slot="media" />
                        </ListInput>
                      </List>
                    </CardContent>

                    <CardFooter>
                      <Button
                        round
                        fill
                        style={{
                          width: "45%",
                          backgroundImage: "linear-gradient(#FF6969, #E02020)",
                          color: "white",
                        }}
                        onClick={() =>
                          this.$f7.dialog.confirm(
                            "This order will be cancelled!",
                            "Order",
                            () => this.cancleOrder(this.state.popupData.order),
                          )
                        }
                      >
                        {this.state.declineOrderButton} &nbsp;{" "}
                        {this.state.declineOrderButton !== "Decline Order" && (
                          <Preloader></Preloader>
                        )}
                      </Button>

                      <Button
                        round
                        fill
                        style={{ width: "45%" }}
                        onClick={(e) =>
                          this.completeOrder(this.state.popupData.order)
                        }
                      >
                        {this.state.completeOrderButton === "Complete Order" ? (
                          this.state.completeOrderButton
                        ) : (
                          <Preloader></Preloader>
                        )}
                      </Button>
                    </CardFooter>
                  </Card>
                ) : null}
              </Block>
            ) : null}

            {this.state.popupData.which == "processed-order" ? (
              <Block>
                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">Order Items </CardHeader>

                  <CardContent>
                    <List>
                      {this.state.popupData.order.packages.map(
                        (value, index) => (
                          <ListItem
                            className="show-text"
                            title={value.name}
                            key={index}
                          >
                            <b slot="media">{value.count} x &nbsp;</b>
                            <small slot="after">
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(value.amount)}
                            </small>
                          </ListItem>
                        ),
                      )}
                    </List>
                  </CardContent>
                </Card>

                {this.state.popupData.order.deliveryInclusive && (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardContent>
                      <List>
                        <ListItem className="show-text" title="Delivery Charge">
                          <small slot="after">
                            {new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "NGN",
                            }).format(
                              this.state.popupData.order.userDeliveryCharge,
                            )}
                          </small>
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                )}

                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">User Details</CardHeader>

                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.fullName}
                        after="Client Name"
                      >
                        <Icon f7="person_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.deliveryAddress}
                        after="Client Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.phoneNumber}
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>

                      {this.state.popupData.order.expectedDeliveryTime ? (
                        <ListItem
                          header="Expected Delivery Time"
                          title={moment(
                            this.state.popupData.order.expectedDeliveryTime,
                          ).format("dddd, MMMM Do, YYYY | hh:mma")}
                          after="EDT"
                        >
                          <Icon f7="cube_box_fill" slot="media" />
                        </ListItem>
                      ) : null}

                      {this.state.popupData.order.instructions &&
                        this.state.popupData.order.instructions.trim() !==
                          "" && (
                          <ListItem
                            className="show-text"
                            title={this.state.popupData.order.instructions}
                            after="Instruction"
                          >
                            <Icon f7="info_circle_fill" slot="media" />
                          </ListItem>
                        )}
                    </List>
                  </CardContent>

                  <CardFooter>
                    <Button
                      outline
                      style={{ width: "45%" }}
                      popupClose
                      href={`tel://${this.state.popupData.order.phoneNumber}`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.state.popupData.order.phoneNumber,
                        )
                      }
                    >
                      <Icon f7="phone_fill_arrow_up_right" />
                      &nbsp;&nbsp;&nbsp;Contact Client
                    </Button>

                    <Button
                      outline
                      style={{ width: "45%" }}
                      onClick={() => this.$f7.methods.navMessage()}
                    >
                      <Icon f7="bubble_left_bubble_right" />
                      &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                    </Button>
                  </CardFooter>
                </Card>

                {!this.state.popupData.order.deliveryInclusive && (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardHeader className="no-border">
                      Assigned Delivery Agent
                    </CardHeader>

                    {this.state.popupData.order.agent ? (
                      <>
                        <CardContent>
                          <List>
                            <ListItem
                              className="show-text"
                              title={this.state.popupData.order.agent.name}
                              after="Agent Name"
                            >
                              <Icon f7="briefcase" slot="media" />
                            </ListItem>
                            <ListItem
                              className="show-text"
                              title={this.state.popupData.order.agent.address}
                              after="Agent Address"
                            >
                              <Icon f7="placemark_fill" slot="media" />
                            </ListItem>
                            <ListItem
                              title={this.state.popupData.order.agent.phone}
                              after="Agent Phone"
                            >
                              <Icon
                                f7="phone_fill_arrow_up_right"
                                slot="media"
                              />
                            </ListItem>
                            {this.state.popupData.order.agent?.branch ? (
                              <List>
                                <ListItem
                                  className="show-text"
                                  title={
                                    this.state.popupData.order.agent?.branch
                                      .name
                                  }
                                  after="Branch Name"
                                >
                                  <Icon f7="arrow_branch" slot="media" />
                                </ListItem>
                                <ListItem
                                  className="show-text"
                                  title={
                                    this.state.popupData.order.agent?.branch
                                      .address
                                  }
                                  after="Branch Address"
                                >
                                  <Icon f7="placemark_fill" slot="media" />
                                </ListItem>
                                <ListItem
                                  className="show-text"
                                  title={
                                    this.state.popupData.order.agent?.branch
                                      .phone
                                  }
                                  after="Branch Phone"
                                >
                                  <Icon
                                    f7="phone_fill_arrow_up_right"
                                    slot="media"
                                  />
                                </ListItem>
                              </List>
                            ) : null}
                          </List>
                        </CardContent>

                        <CardFooter>
                          <Button
                            outline
                            style={{
                              width: this.state.popupData.order.agent?.branch
                                ? "30%"
                                : "45%",
                            }}
                            popupClose
                            href={`tel://${this.state.popupData.order.agent.phone}`}
                            external
                            onClick={() =>
                              this.$f7.methods.phoneCall(
                                this.state.popupData.order.agent.phone,
                              )
                            }
                          >
                            <Icon f7="phone_fill_arrow_up_right" />
                            &nbsp;&nbsp;&nbsp;Contact Agent
                          </Button>
                          {this.state.popupData.order.agent?.branch ? (
                            <Button
                              outline
                              style={{ width: "30%" }}
                              href={`tel://${this.state.popupData.order.agent?.branch?.phone}`}
                              external
                              onClick={() =>
                                this.$f7.methods.phoneCall(
                                  this.state.popupData.order.agent?.branch
                                    ?.phone,
                                )
                              }
                            >
                              <Icon f7="phone_fill_arrow_up_right" />
                              &nbsp;&nbsp;&nbsp;Call Delivery Branch
                            </Button>
                          ) : null}
                          <Button
                            outline
                            style={{
                              width: this.state.popupData.order.agent?.branch
                                ? "30%"
                                : "45%",
                            }}
                            onClick={() => this.$f7.methods.navMessage()}
                          >
                            <Icon f7="bubble_left_bubble_right" />
                            &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                          </Button>
                        </CardFooter>
                      </>
                    ) : (
                      <CardContent>
                        <Block
                          style={{
                            backgroundColor: "#ffe0b2",
                            borderLeft: "3px solid #ff9800",
                            color: "#ef6c00",
                            marginTop: 0,
                            paddingTop: "16px",
                            paddingBottom: "16px",
                            fontSize: "10px",
                          }}
                        >
                          <Row>
                            <Col>
                              <p>Order was for pick up only!</p>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    )}
                  </Card>
                )}

                {this.state.popupData.order.issue &&
                  this.state.popupData.order.issue.trim() !== "" && (
                    <Card style={{ margin: "10pt auto" }}>
                      <CardHeader className="no-border">Issue</CardHeader>
                      <CardContent>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.popupData.order.issue,
                          }}
                        ></div>
                      </CardContent>
                      <CardFooter>Reported by delivery agent</CardFooter>
                    </Card>
                  )}
              </Block>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  componentDidMount() {
    this.getNearestBranches();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.deliveryAgentsRange !== this.state.deliveryAgentsRange) {
      this.getNearestBranches();
    }
  }

  // events
  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : "admin";
    const previousView = args[0] ? args[0] : "account";
    const previousPage = args[2] ? args[2] : "account";

    self.$f7.views["message-master"].router.navigate(
      {
        name: "message-master",
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      },
    );
  }

  async getNearestBranches() {
    try {
      // Find cities within range
      const center = [
        this.props.merchants[this.props.auth.uid].businessProfile.geoLoc.lat,
        this.props.merchants[this.props.auth.uid].businessProfile.geoLoc.lng,
      ];
      const radiusInM = this.state.deliveryAgentsRange * 1000;

      // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
      // a separate query for each pair. There can be up to 9 pairs of bounds
      // depending on overlap, but in most cases there are 4.
      const bounds = geofire.geohashQueryBounds(center, radiusInM);
      const promises = [];
      for (const b of bounds) {
        const q = this.props.firestore
          .collectionGroup("branches")
          .orderBy("geohash")
          .startAt(b[0])
          .endAt(b[1]);

        promises.push(q.get());
      }

      // Collect all the query results together into a single list
      Promise.all(promises).then((snapshots) => {
        const matchingDocs = [];

        for (const snap of snapshots) {
          for (const doc of snap.docs) {
            const lat = doc.get("geoLoc.lat");
            const lng = doc.get("geoLoc.lng");

            // We have to filter out a few false positives due to GeoHash
            // accuracy, but most will match
            const distanceInKm = geofire.distanceBetween([lat, lng], center);
            const distanceInM = distanceInKm * 1000;
            if (distanceInM <= radiusInM) {
              matchingDocs.push({
                HQId: doc.ref.parent.parent.id,
                id: doc.id,
                ...doc.data(),
              });
            }
          }
        }

        const formattedMatchingDocs = matchingDocs.filter(
          ({ HQId, suspended }) =>
            !suspended &&
            this.props.data?.delivery[HQId].accountStatus === "Approved",
        );

        this.setState({
          ...this.state,
          nearestBranches: formattedMatchingDocs,
        });
      });
    } catch (error) {
      console.log(error);
    }
  }

  // complete order
  completeOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, completeOrderButton: "" });
    if (this.state.confirmationCode.trim() === "") {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, completeOrderButton: "Complete Order" });
      return toast(this.$f7.toast, {
        text: "Please enter the confirmation code provided by the customer",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (order.confirmationCode) {
      if (order.confirmationCode === this.state.confirmationCode) {
        this.props.firestore
          .collection("orders")
          .doc(order.id)
          .update({
            orderStatus: "Order Completed",
            completed: true,
            confirmationTime: Date.now(),
          })
          .then(() => {
            this.$f7.preloader.hide();
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "", order: "" },
              completeOrderButton: "Complete Order",
              confirmationCode: "",
            });
            return toast(this.$f7.toast, {
              text: "Order confirmed",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.setState({
              ...this.state,
              completeOrderButton: "Complete Order",
            });
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          });
      } else {
        this.$f7.preloader.hide();
        this.setState({ ...this.state, completeOrderButton: "Complete Order" });
        return toast(this.$f7.toast, {
          text: "Confirmation code not correct, please input the correct code.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      }
    } else {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, completeOrderButton: "Complete Order" });
      return toast(this.$f7.toast, {
        text: "Confirmation code has not been generated by the customer",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  cancleOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, declineOrderButton: "" });

    // Update order status
    this.props.firestore
      .collection("orders")
      .doc(order.id)
      .update({
        orderStatus: "Order Cancelled",
        cancelTimestamp: Date.now(),
        cancelledByAdminOrSupport: null,
      })
      .then(() => {
        this.setState({
          ...this.state,
          popupOpened: false,
          declineOrderButton: "Decline Order",
        });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: "Order Cancelled",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          declineOrderButton: "Decline Order",
        });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  processOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, processDeliveryButton: "" });

    if (this.state.selectedDeliveryAgent.trim() === "") {
      this.setState({ ...this.state, processDeliveryButton: "Process Order" });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Please select an agent to deliver the package",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } else {
      const branch = this.state.nearestBranches.find(
        ({ id }) => id === this.state.selectedDeliveryAgent,
      );
      const assignedAgentId = branch
        ? branch.HQId
        : this.state.selectedDeliveryAgent;

      const isBranch = branch ? true : false;

      const agent = {
        name: this.props.data.delivery[assignedAgentId].businessProfile.name,
        address:
          this.props.data.delivery[assignedAgentId].businessProfile.address,
        phone: this.props.data.delivery[assignedAgentId].businessProfile.phone,
        branch: isBranch
          ? {
              id: branch.id,
              name: branch.name,
              address: branch.address,
              phone: branch.phone,
            }
          : null,
      };

      this.props.firestore
        .collection("orders")
        .doc(order.id)
        .update({
          assignedAgentId,
          agent,
          orderStatus: "Order Pending Delivery",
        })
        .then(() => {
          this.setState({
            ...this.state,
            popupOpened: false,
            processDeliveryButton: "Process Order",
            selectedDeliveryAgent: "",
          });
          return toast(this.$f7.toast, {
            text: "Order Processed",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        })
        .catch((error) => {
          this.setState({
            ...this.state,
            processDeliveryButton: "Process Order",
          });
          return toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        });

      this.$f7.preloader.hide();
    }
  }
}

const mapStateToProps = ({
  firebase: { auth },
  DB: {
    docs: { loading, orders },
    ordered,
    data,
  },
}) => ({
  auth,
  ordered,
  data,
  loadingDoc: loading,
  orders: (orders && orders) || [],
});

const enhance = compose(
  withStorage,
  firestoreConnect((props) => [
    new Collections("delivery"),
    new Collections("settings"),
    new DocArray(
      "orders",
      props.merchants && props.merchants[props.auth.uid]
        ? props.auth.uid
        : null,
      "merchantId",
    ),
  ]),
  connect(mapStateToProps),
);

export default enhance(Merchant);
